import { Divider, Flex } from 'antd';
import { CDN_MARKETPLACE } from '../../../components/scene/assets/baseUrl';
import { memo } from 'react';
import { useRouter } from 'next/router';
import { ZepetoTechTextLogo } from '../zepeto/ZepetoTechTextLogo';

const XsollaLogo = ({ styles }) => {
  const router = useRouter();
  function redirectMain() {
    router.push('/');
  }
  return (
    <Flex align='center' gap={12} className={styles.xsolla}>
      <Flex gap={10} className={styles.xsollaWrapper} onClick={redirectMain}>
        <div className={styles.logoWrapper}>
          <img
            src={`${CDN_MARKETPLACE}/assets/logos/xsolla-logo.svg`}
            alt='XSOLLA'
            style={{ objectFit: 'contain', height: '42px' }}
            className={styles.xsollaLogo}
          />
        </div>
        <div className={styles.xsollaText}>Xsolla</div>
      </Flex>
    </Flex>
  );
};

export default memo(XsollaLogo);
